/* eslint-disable react/jsx-curly-newline */
export default (theme) => ({
  toastWrapper: {
    position: 'fixed',
    bottom: '30px',
    right: '0px',
    zIndex: 100,
    pointerEvents: 'none',
  },
  wrap: {
    extend: theme.wrapper,
    position: 'relative',
  },
  notification: {
    padding: '15px 30px',
    // border: `solid 2px ${theme.colors[5]}`,
    backgroundColor: theme.colors[5],
    boxShadow: 'rgb(0 0 0 / 16%) 0px 1px 2px 0px',
    opacity: 0,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    // pointerEvents: 'all',
    cursor: 'pointer',
  },
  progressBar: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    height: 2,
    width: '100%',
    backgroundColor: theme.colors[0],
    transformOrigin: 'right center',
  },
  figure: {
    margin: '0px',
    marginRight: '20px',
    height: '80px',
    width: '80px',
    borderRadius: '50%',
    overflow: 'hidden',
    boxShadow: 'rgb(0 0 0 / 16%) 0px 1px 2px 0px',
    padding: '11px',
    backgroundColor: theme.colors[1],
    '& img': {
      height: '100%',
      width: 'auto',
    },
  },
  textWrapper: {
    '& p': {
      margin: 0,
    },
    '& .message': {
      marginBottom: '5px',
      fontSize: '14px',
    },
    '& .designer': {
      fontWeight: 300,
      fontSize: '12px',
    },
  },
})
